
import { updateAccount, deleteAccount, registerAccount, getAccountType, getUserByEmailAddress } from './BusinessAccountService';
import { extractError } from '../../api/ErrorUtil';
import { evenRound } from 'util/NumberUtils';
import _ from "lodash";

export const businessAccountFormDataInitialState = {
  id: '',
  number: '',
  accountTypeId: "",
  address: '',
  city: '',
  state: 'ON',
  zip: '',
  country: 'CA',
  email: '',
  firstName: '',
  lastName: '',
  companyName: '',
  mobilePhoneNumber: '',
  associatedUserId: '',
  accountTypes: [],
  successmessage: [],
  infoMessage: '',
  loading: false,
  newAccount: true,
  redirectToEdit: false,
  accountType: {}
}

const getBusinessAccountObjectFromForm = (data, accntTypes) => {
  let accType = getAccountType(data.accountTypeId, accntTypes)
  return {
    id: data.id,
    number: data.number ? data.number : null,
    accountType: accType.type,
    firstName: data.firstName,
    lastName: data.lastName,
    companyName: data.companyName,
    mobilePhoneNumber: data.mobilePhoneNumber,
    address: data.address,
    city: data.city,
    state: data.state,
    zip: data.zip,
    country: data.country,
    // accountVerificationPin:data.verificationPin
    email: data.email,
    
  }
}

export const AsyncBusinessAccountDataHandlers = {
  FORM_SUBMIT: ({ dispatch, getState, signal }) => async (action) => {
    let { formData } = action.payload;
    dispatch({ type: 'FORM_SUBMITTING' });
    let businessAccountOpResponse = null;
    let redirectToEdit = false;
    try {

      if (formData.type === 'Add') {
        businessAccountOpResponse = await registerAccount(getBusinessAccountObjectFromForm(formData, formData.accountTypes));
        redirectToEdit = true;
      } else if (formData.type === 'Delete') {
        businessAccountOpResponse = await deleteAccount(formData.id);
      } else {
        //for update dont send account type or number
        businessAccountOpResponse = await updateAccount(formData.id, { ...getBusinessAccountObjectFromForm(formData, formData.accountTypes) });
      }

      dispatch({ type: 'FORM_SUBMIT_SUCCESS', payload: { response: businessAccountOpResponse, redirectToEdit: redirectToEdit } });

    } catch (error) {
      console.log(error);
      let errorMsg = extractError(error);
      console.log(errorMsg);
      dispatch({ type: 'FORM_SUBMIT_FAIL', payload: { error: errorMsg } });
    }
  },

  POPULATE_USER_DETAILS_FROM_EMAIL: ({ dispatch, getState, signal }) => async (action) => {
    const { email } = action.payload;
    if (!email) {
      return;
    }
    let user = await getUserByEmailAddress(email);
    if (!user) {
      return;
    }
    dispatch({ type: 'POPULATE_USER_DETAILS', payload: { user: user } });
  }

};

export const BusinessAccountFormDataReducer = (state, action) => {

  if (action.type === 'SELECT_ACCOUNT_TYPE') {
    let { name, value } = action.payload;
    let accType = getAccountType(value, state.accountTypes);
    return {
      ...state,
      [name]: value,
      accountType: accType
    };
  }

  if (action.type === 'POPULATE_FORM') {

    let { account, accountTypes } = action.payload;

    if (account) {
      let businessAccount = {
        id: account.id,
        number: account.number,
        accountTypeId: account.accountTypeId,
        firstName: account.firstName,
        lastName: account.lastName,
        companyName: account.companyName,
        mobilePhoneNumber: account.mobilePhoneNumber,
        address: account.address,
        city: account.city,
        state: account.state,
        zip: account.zip,
        country: account.country,
        // verificationPin:accountData.accountVerificationPin        
        email: account.email,
      } 
      let accType = getAccountType(account.accountTypeId, accountTypes);
      return { ...businessAccount, accountTypes: accountTypes, accountType: accType, newAccount: false };
    } else {
      if (accountTypes.length === 1){
          return { ...state,accountTypes: accountTypes, accountTypeId:accountTypes[0].id,newAccount: true };  
      }
      return { ...state,accountTypes: accountTypes, newAccount: true };
    }
  }

  if (action.type === 'POPULATE_USER_DETAILS') {
    const { user } = action.payload;
    return {
      ...state,
      firstName: user.firstName,
      lastName: user.lastName,
      companyName: user.companyName,
      mobilePhoneNumber: user.mobilePhoneNumber,
      address: user.address,
      city: user.city,
      state: user.state,
      zip: user.zip,
      country: user.country
    }

  }

  if (action.type === 'FIELD_CLEAR') {
    return businessAccountFormDataInitialState;
  }

  if (action.type === 'FORM_SUBMITTING') {
    return {
      ...state,
      readOnly: true,
      status: "Submitting Form...",
      infoMessage: '',
      errors: {},
      loading: true
    }
  }

  if (action.type === 'FORM_SUBMIT_SUCCESS') {
    let { response, redirectToEdit } = action.payload;

    let newState = {
      ...state,
      ...response,
      readOnly: redirectToEdit,
      successmessage: response.message,
      infoMessage: response.message,
      errors: {},
      loading: false,
      newAccount: false,
      redirectToEdit: redirectToEdit
    };

    return newState;
  }

  if (action.type === 'FORM_SUBMIT_FAIL') {
    let { error } = action.payload;
    let newState = {
      ...state,
      readOnly: false,
      errors: error,
      loading: false
    };
    return newState;
  }

  if (action.type === 'FIELD_EDIT') {
    const { name, value } = action.payload;
    let newState = {
      ...state,
      [name]: value
    };
    return newState;
  }

  if (action.type === 'ERROR') {
    const { errors } = action.payload;
    return {
      ...state,
      errors: errors
    }
  }

  if (action.type === 'CLEAR_INFO_AND_ERROR') {
    return {
      ...state,
      infoMessage: "",
      errors: {}
    }

  }

  //the following is for form edit and hence there should be a payload.
  //otherwise just return state
  if (!action.payload) {
    return state;
  }

}